import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import Label from '@/Controls/Label';

export default class DummyControlFactory extends ControlFactory {

    private jQueryControl: JQuery;
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel')
    protected Label = ComponentManager.getControl<typeof Label>('Label');

    /**
     * @override
     */
    public viewModel: LabelViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: Label;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.LabelViewModel({
            factory: this,
            isRequired: this.isRequired,
            caption: 'Factory "' + this.detailViewItem.uiGenerator + '" could not be resolved.',
            isErrorLabel: true
        });

        this.control = new this.Label(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('DummyControl', DummyControlFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');